import Skeleton from "react-loading-skeleton";
import "./SkeletonLoading.css";

export function SkeletonVerticalProgressStepBar() {
  return (
    <div className="skeleton">
      <div className="skeleton-row">
        <div className="left-col">
          <Skeleton circle width={24} height={24} />
        </div>
        <div className="right-col">
          <Skeleton />
        </div>
      </div>
      <div className="skeleton-row">
        <div className="left-col">
          <Skeleton circle width={24} height={24} />
        </div>
        <div className="right-col">
          <Skeleton />
        </div>
      </div>
      <div className="skeleton-row">
        <div className="left-col">
          <Skeleton circle width={24} height={24} />
        </div>
        <div className="right-col">
          <Skeleton />
        </div>
      </div>
      <div className="skeleton-row">
        <div className="left-col">
          <Skeleton circle width={24} height={24} />
        </div>
        <div className="right-col">
          <Skeleton />
        </div>
      </div>
      <div className="skeleton-row">
        <div className="left-col">
          <Skeleton circle width={24} height={24} />
        </div>
        <div className="right-col">
          <Skeleton />
        </div>
      </div>
    </div>
  );
}

export function SkeletonBiocode() {
  return (
    <div className="skeleton-biocode">
      <div className="skeleton-biocode-square">
        <Skeleton height={32} />
      </div>
      <div className="skeleton-biocode-square">
        <Skeleton height={32} />
      </div>
      <div className="skeleton-biocode-square">
        <Skeleton height={32} />
      </div>
      <div className="skeleton-biocode-square">
        <Skeleton height={32} />
      </div>
      <div className="skeleton-biocode-square">
        <Skeleton height={32} />
      </div>
      <div className="skeleton-biocode-square">
        <Skeleton height={32} />
      </div>
      <div className="skeleton-biocode-square">
        <Skeleton height={32} />
      </div>
      <div className="skeleton-biocode-square">
        <Skeleton height={32} />
      </div>
      <div className="skeleton-biocode-square">
        <Skeleton height={32} />
      </div>
      <div className="skeleton-biocode-square">
        <Skeleton height={32} />
      </div>
    </div>
  );
}

export function SkeletonDimensions({ showPrice = true }) {
  return (
    <div className="skeleton-dimensions">
      <div className="skeleton-dimensions-first">
        <Skeleton width={150} />
        <Skeleton width={240} />
      </div>
      {showPrice && (
        <div className="skeleton-dimensions-second">
          <Skeleton width={110} />
          <Skeleton width={110} />
        </div>
      )}
    </div>
  );
}

export function SkeletonDescriptionWidget() {
  return (
    <div className="skeleton-description-widget">
      <div className="skeleton-description-widget-image">
        <Skeleton height={130} />
      </div>
      <div className="skeleton-description-widget-text">
        <div style={{ marginBottom: "10px", width: "100%" }}>
          <Skeleton count={6} />
        </div>
        <div style={{ width: "100%", gap: "4px" }}>
          <Skeleton style={{ gap: "4px" }} count={6} />
        </div>
      </div>
    </div>
  );
}

export function SkeletonOptions() {
  function SkeletonOption() {
    return (
      <div className="skeleton-option">
        <div className="skeleton-option-image">
          <Skeleton width={100} height={100} />
        </div>
        <div className="skeleton-option-text">
          <Skeleton
            style={{ marginBottom: "10px", marginLeft: "10px" }}
            width={70}
          />
          <Skeleton style={{ marginLeft: "10px" }} width={380} count={3} />
        </div>
      </div>
    );
  }

  return (
    <div className="skeleton-options">
      <Skeleton width={150} />
      <Skeleton width={250} />
      <div
        style={{ width: "100%", height: "2px", backgroundColor: "#f0efec" }}
      ></div>
      <SkeletonOption />
      <SkeletonOption />
    </div>
  );
}

export function SkeletonHorizontalStepper() {
  return <Skeleton height={5} />;
}

export function SkeletonEstimateOverviewElementCard() {
  return (
    <div className="skeleton">
      <div className="skeleton-row">
        <div className="skeleton-estimate-overview">
          <div className="skeleton-estimate-overview-counter">
            <div className="skeleton-estimate-overview-square">
              <Skeleton width={32} height={32} />
            </div>
            <div className="skeleton-estimate-overview-square">
              <Skeleton width={32} height={32} />
            </div>
            <div className="skeleton-estimate-overview-square">
              <Skeleton width={32} height={32} />
            </div>
          </div>
          <div className="skeleton-estimate-overview-image">
            <Skeleton height={100} />
          </div>
          <div className="skeleton-estimate-overview-text">
            <Skeleton width={140} />
            <Skeleton width={80} />
          </div>
          <div className="skeleton-estimate-overview-divider"></div>
          <div className="skeleton-estimate-overview-biocode">
            <SkeletonBiocode />
          </div>
        </div>
      </div>
      <div className="skeleton-row">
        <div className="skeleton-estimate-overview">
          <div className="skeleton-estimate-overview-counter">
            <div className="skeleton-estimate-overview-square">
              <Skeleton width={32} height={32} />
            </div>
            <div className="skeleton-estimate-overview-square">
              <Skeleton width={32} height={32} />
            </div>
            <div className="skeleton-estimate-overview-square">
              <Skeleton width={32} height={32} />
            </div>
          </div>
          <div className="skeleton-estimate-overview-image">
            <Skeleton height={100} />
          </div>
          <div className="skeleton-estimate-overview-text">
            <Skeleton width={140} />
            <Skeleton width={80} />
          </div>
          <div className="skeleton-estimate-overview-divider"></div>
          <div className="skeleton-estimate-overview-biocode">
            <SkeletonBiocode />
          </div>
        </div>
      </div>
    </div>
  );
}
